const SHARED_REPORT_ROUTE_PATTERN = /^\/shared\/report(?:\/|$)/i;
const ABSOLUTE_URL_PATTERN = /^[a-z][a-z0-9+.-]*:\/\//i;

export const REDACTED_SHARED_REPORT_PATH = '/shared/report/[redacted]';

const extractPathname = (value: string): string => {
  if (!value) return '/';

  try {
    if (ABSOLUTE_URL_PATTERN.test(value)) {
      return new URL(value).pathname || '/';
    }
    return new URL(value, 'https://app.xprojex.com').pathname || '/';
  } catch {
    return '/unavailable';
  }
};

export const isSensitiveCredentialRoute = (
  pathname: string = typeof window === 'undefined' ? '/' : window.location.pathname,
): boolean => SHARED_REPORT_ROUTE_PATTERN.test(extractPathname(pathname));

export const getPrivacySafePath = (
  value: string = typeof window === 'undefined' ? '/' : window.location.pathname,
): string => {
  const pathname = extractPathname(value);
  return isSensitiveCredentialRoute(pathname) ? REDACTED_SHARED_REPORT_PATH : pathname;
};

export const getPrivacySafeCurrentUrl = (): string => {
  const pathname = getPrivacySafePath();
  if (typeof window === 'undefined') return pathname;
  return `${window.location.origin}${pathname}`;
};
